<template>
  <v-container>
    <v-sheet height="32px">
      <v-toolbar flat color="white" height="30px">
        <v-toolbar-title small>{{ $t('title.config') }}</v-toolbar-title>
      </v-toolbar>
    </v-sheet>
    
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row>
        <v-col :xs="12" :sm="12" :md="12">
          <v-text-field
            v-model="name"
            :counter="50"
            :rules="nameRules"
            :label="$t('label.baby_name')"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-menu
            ref="menuDob"
            v-model="dobMenu"
            :return-value.sync="dob"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dob"
                :label="$t('label.dob')"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="dateRules"
              >
              </v-text-field>
            </template>
            <v-date-picker
              v-if="dobMenu"
              locale="ja-jp"
              v-model="dob"
              :day-format="date => new Date(date).getDate()"
              @click:date="$refs.menuDob.save(dob)"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-radio-group
            row
            v-model="gender"
            :label="$t('label.gender')"
            :rules="genderRules"
          >
            <v-radio
              v-for="(item, index) in this.$gender.getOptions()"
              :key="index"
              :label="item.label"
              :value="item.id"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            block
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="validate"
          >
            {{ $t('label.save') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            block
            class="mr-4"
            outlined
            @click="cancel"
          >
            {{ $t('label.cancel') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            block
            color="info"
            class="mr-4"
            outlined
            @click.stop="importExportDialog = true"
          >
            {{ $t('label.import-export') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            block
            color="error"
            class="mr-4"
            outlined
            @click.stop="allClearDialog = true"
          >
            {{ $t('label.all-clear') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-dialog
      v-model="allClearDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{ $t('title.delete-menu') }}</v-card-title>
        <v-card-text>
          {{ $t('msg.all-clear-confirm') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="gray"
            text
            @click="allClearDialog = false"
          >
            {{ $t('label.cancel') }}
          </v-btn>
          <v-btn
            color="red darken-3"
            text
            @click="allClear()"
          >
            {{ $t('label.delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="importExportDialog"
    >
      <v-card class="pa-4">
        <v-card-title class="headline">{{ $t('label.import-export') }}</v-card-title>
        <v-card-text>
          {{ $t('msg.import-export') }}
        </v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn
              block
              color="info"
              outlined
              @click="exportMenu()"
              @click.stop="importExportDialog = false"
            >
              {{ $t('label.export') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-file-input
              :label="$t('label.import-select')"
              @change="fileRead"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              block
              text
              color="gray"
              @click="importExportDialog = false"
            >
              {{ $t('label.cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    
    <v-dialog
      v-model="importConfirm"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{ $t('title.import-confirm') }}</v-card-title>
        <v-card-text>
          {{ $t('msg.import-confirm') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="gray"
            text
            @click="importConfirm = false"
          >
            {{ $t('label.cancel') }}
          </v-btn>
          <v-btn
            color="red darken-3"
            text
            @click="executeImport()"
          >
            {{ $t('label.import') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    allClearDialog: false,
    importExportDialog: false,
    importConfirm: false,
    importFile: null,
    dobMenu: false,
    nameRules: [
      v => !!v || '赤ちゃんの名前は必須入力です。',
      v => (v && v.length <= 50) || '赤ちゃんの名前は50文字以内で入力してください。',
    ],
    dateRules: [
      v => !!v || '誕生日は必須入力です。',
    ],
    genderRules: [
      v => !!v || '性別は必須入力です。',
    ],
    name: null,
    gender: null,
    dob: null
  }),
  computed: {
  },
  mounted() {
    const babyData = this.$storage.getBabyData()
    if (babyData !== null) {
      this.name = babyData.name
      this.dob = babyData.dob
      this.gender = babyData.gender
      this.memo = babyData.memo
    } else {
      if (!this.$storage.getAbout()) {
        this.$router.push({ name: 'About' })
      }
    }
  },
  methods: {
    allowedStep: m => m % 10 === 0,
    validate () {
      if (!this.$refs.form.validate()) {
        return
      }
      const data = {
        name: this.name,
        dob: this.dob,
        gender: this.gender
      }
      const result = this.$storage.setBabyData(data)
      if (!result) {
        alert('')
      } else {
        this.$router.push({ name: 'Dashboard' })
      }
    },
    cancel () {
      if (this.$storage.getBabyData() == null) {
        alert('赤ちゃんの情報を登録してください')
      } else {
        this.$router.push({ name: 'Dashboard' })
      }
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    allClear () {
      this.$storage.clear()
      this.allClearDialog = false
      this.$router.push({ name: 'Dashboard' })
    },
    fileRead (file) {
      this.importFile = file
      this.importConfirm = true
    },
    executeImport () {
      const _this = this
      let reader = new FileReader()
      reader.onload = function() {
        const jsonStr = reader.result
        const isSuccess = _this.$storage.importJson(jsonStr)
        if (!isSuccess) {
          alert(_this.$i18n.t('msg.invalid-menu-json'))
        } else {
          confirm(_this.$i18n.t('msg.import-complete'))
        }
      };
      reader.readAsText(this.importFile, 'UTF-8')
      this.importConfirm = false
      this.importExportDialog = false
    },
    exportMenu () {
      const fileName = "babyfood.json";
      const data = JSON.stringify(this.$storage.extractMenuData())
      const link = document.createElement("a");
      link.href = "data:text/plain," + encodeURIComponent(data);
      link.download = fileName;
      link.click();
    }
  },
};
</script>
<style>
</style>